import React from 'react';
import { InstallationIcon, ReparationIcon } from './PlumbingIcons';

interface ServiceTypeButtonProps {
  label: string;
  onClick: () => void;
  active?: boolean;
  large?: boolean;
  type: 'installation' | 'reparation';
}

const ServiceTypeButton: React.FC<ServiceTypeButtonProps> = ({ label, onClick, active = false, large = false, type }) => {
  const IconComponent = type === 'installation' ? InstallationIcon : ReparationIcon;
  
  return (
    <button 
      onClick={onClick}
      className={`flex flex-col items-center justify-center w-full p-4 rounded-xl transition-all duration-300 transform hover:scale-102 ${active ? 'bg-primary/5' : 'hover:bg-gray-50'}`}
    >
      <div className={`${large ? 'w-32 h-32' : 'w-24 h-24'} rounded-full border-2 shadow-sm transition-all duration-300 ${
        active 
          ? 'border-primary bg-white shadow-md' 
          : 'border-gray-200 bg-white hover:border-primary/50'
      } flex items-center justify-center mb-4`}>
        <div className={`flex items-center justify-center`}>
          <IconComponent size={large ? "large" : "medium"} />
        </div>
      </div>
      <span className={`${large ? 'text-xl' : 'text-base'} text-center font-medium transition-colors duration-300 ${active ? 'text-primary' : 'text-gray-700'}`}>
        {label}
        {active && <div className="h-0.5 w-1/2 bg-primary mx-auto mt-1 rounded-full"></div>}
      </span>
    </button>
  );
};

interface ServiceTypeButtonsProps {
  activeType: 'installation' | 'reparation' | null;
  onTypeChange: (type: 'installation' | 'reparation') => void;
  largeButtons?: boolean;
}

const ServiceTypeButtons: React.FC<ServiceTypeButtonsProps> = ({ activeType, onTypeChange, largeButtons = false }) => {
  return (
    <div className={`flex justify-center ${largeButtons ? 'space-x-12' : 'space-x-8'} p-6 bg-white shadow-md rounded-2xl`}>
      <ServiceTypeButton 
        label="Installation" 
        onClick={() => onTypeChange('installation')}
        active={activeType === 'installation'}
        large={largeButtons}
        type="installation"
      />
      <ServiceTypeButton 
        label="Réparation" 
        onClick={() => onTypeChange('reparation')}
        active={activeType === 'reparation'}
        large={largeButtons}
        type="reparation"
      />
    </div>
  );
};

export default ServiceTypeButtons; 